import React, { PureComponent, Fragment } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import Sources from './Modals/Sources';
import NextReminder from './Modals/NextReminder';
import LastCheckup from './Modals/LastCheckup';
import AdditionalInfo from './Modals/AdditionalInfo';
import OptIn from '../../../../../WebPush/OptIn';
import { canAskToEnablePush, hasAcceptedPush } from '../../../../../WebPush/util';
import { PUSH_OPT_IN_ORIGIN_HEALTH_CHECKLIST } from '../../../../../../constants/index';
import { analyticsTrackEvent } from '../../../../../../core/analytics';
import { WEB_PUSH_OPT_IN } from '../../../../../../core/analytics/events';
import { isNativeApp } from '../../../../../../core/util/device';
import { WEB_PUSH_OPT_IN_MODAL } from '../../../../../../constants/modalIds';
import { UserProfile } from '~/core/dapi/models';
import { NativeFunctions } from '~/core/util/native';
import { Tile } from './Tile';

const SmallDialog = styled(Dialog).withConfig({ componentId: 'sc-z1847p-0' })`
  .paper-root {
    margin: 24px;
  }
`;

type Props = {
  openModal: (
    modalId?: string | null,
    options?: {
      lastCheckupResponseInDays: number;
    }
  ) => any;
  activeModalId?: string | null;
  activeTask?: string;
  userProfile?: UserProfile;
  activeTile?: Tile | null;
};

export default class ModalController extends PureComponent<Props> {
  get modalProps() {
    return { onClose: this.closeModal, ...this.props };
  }

  dialogProps = (modalId: any) => ({
    open: this.props.activeModalId === modalId,
    onClose: this.closeModal,
    PaperProps: { classes: { root: 'paper-root' } },
  });

  closeModal = () => this.props.openModal(null);

  closeReminder = () => {
    canAskToEnablePush() && !hasAcceptedPush()
      ? this.openPushNotificationFlow()
      : this.closeModal();
  };

  iosAppPushNotificationsFlow = () => {
    this.closeModal();
    NativeFunctions.handleAcceptPushPermissions.call(PUSH_OPT_IN_ORIGIN_HEALTH_CHECKLIST);
  };

  openPushNotificationFlow = () =>
    isNativeApp() ? this.iosAppPushNotificationsFlow() : this.openOptInModal();

  openOptInModal = () => {
    this.props.openModal(WEB_PUSH_OPT_IN_MODAL);
    analyticsTrackEvent(WEB_PUSH_OPT_IN, {
      webPushOptInOrigin: PUSH_OPT_IN_ORIGIN_HEALTH_CHECKLIST,
      action: 'open modal',
    });
  };

  render() {
    const { userProfile } = this.props;

    return (
      <>
        <SmallDialog {...this.dialogProps(Sources.MODAL_ID)}>
          <Sources {...this.modalProps} />
        </SmallDialog>

        <SmallDialog {...this.dialogProps(NextReminder.MODAL_ID)}>
          <NextReminder {...this.modalProps} onClose={this.closeReminder} />
        </SmallDialog>

        <SmallDialog {...this.dialogProps(LastCheckup.MODAL_ID)}>
          <LastCheckup {...this.modalProps} />
        </SmallDialog>

        <SmallDialog {...this.dialogProps(AdditionalInfo.MODAL_ID)}>
          <AdditionalInfo {...this.modalProps} />
        </SmallDialog>

        <SmallDialog {...this.dialogProps(WEB_PUSH_OPT_IN_MODAL)}>
          <OptIn
            {...this.modalProps}
            accountId={userProfile && userProfile.account_id}
            handleAcceptCustomBehavior={this.closeModal}
            handleDenyCustomBehavior={this.closeModal}
            webPushOptInOrigin={PUSH_OPT_IN_ORIGIN_HEALTH_CHECKLIST}
          />
        </SmallDialog>
      </>
    );
  }
}
